import { OrganizationActualStaffFragment } from "gql/graphql";
import { Hidable, Value } from "@/shared/value";

/** Фактическая численность подразделения — сколько единиц занято на самом деле. */
export function OrganizationActualStaff({
  data,
}: {
  data?: Hidable<OrganizationActualStaffFragment>;
}) {
  return (
    <Value data={data}>
      {(organization) => <span>{organization.actualStaff}</span>}
    </Value>
  );
}
